export default "__VITE_ASSET__31jvs4zU__"